function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".frame,.primary{fill:none;}.white{fill:#fff;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "frame",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "white"
}, React.createElement("polygon", {
  className: "white",
  points: "208 24 208 232 48 232 48 76.21 95.46 24 208 24"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("rect", {
  className: "highlights",
  x: 48,
  y: 160,
  width: 160,
  height: 72
})), React.createElement("g", {
  id: "primary"
}, React.createElement("polygon", {
  className: "primary",
  points: "208 24 208 232 48 232 48 76.21 95.46 24 208 24"
}), React.createElement("polygon", {
  className: "primary",
  points: "98.91 24 51.45 76.21 98.91 76.21 98.91 24"
}), React.createElement("line", {
  className: "primary",
  x1: 80,
  y1: 200,
  x2: 176,
  y2: 200
}), React.createElement("line", {
  className: "primary",
  x1: 80,
  y1: 104,
  x2: 112,
  y2: 104
}), React.createElement("line", {
  className: "primary",
  x1: 80,
  y1: 128,
  x2: 112,
  y2: 128
})));
var SvgMarketingContent = function SvgMarketingContent(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarketingContent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MarketingContent.ba95ed2e.svg";
export { ForwardRef as ReactComponent };